function lakuPandaiDigitalTrxTrackerFactory(
  tracker,
  trackerSchema = {
    eventSchema: 'lakupandai_digital_send_event',
  },
) {
  let referrer = 'mitra apps';
  let source = 'mitra apps';
  let digitalTrxJourneyID = null;
  let appJourneyID = null;
  let sourceType = '';
  let channelType = '';
  let subchannel = '';
  let campaignName = '';
  let media = '';
  let dopeKey = '';

  function generateJourneyID(userId, enteringScreenTime) {
    const journeyId = `${userId}-${enteringScreenTime.getTime()}`;
    sessionStorage.setItem('new_tracker_journey_id', journeyId);
    return journeyId;
  }

  function track(evn, additionalData = {}) {
    const enteringScreenTime = new Date();
    const userId = window.blGlobal ? window.blGlobal.user.id : window.USER.id;
    const userIdTrack = userId.toString(36);
    const journeyPayload = {};

    digitalTrxJourneyID =
      sessionStorage.getItem('new_tracker_journey_id') ||
      generateJourneyID(userId, enteringScreenTime);
    journeyPayload.journey_id = digitalTrxJourneyID;
    additionalData.transaction_id = additionalData.transaction_id || '';
    additionalData.referrer = referrer;
    additionalData.source = source;
    additionalData.app_journey_id = appJourneyID || '';
    additionalData.source_type = sourceType;
    additionalData.channel_type = channelType;
    additionalData.subchannel = subchannel;
    additionalData.media = media;
    additionalData.app_journey_id =
      appJourneyID ||
      sessionStorage.getItem('new_tracker_app_journey_id') ||
      '';
    const trackerTime =
      additionalData.timestamp || enteringScreenTime.getTime();
    delete additionalData.timestamp;

    if (dopeKey !== '') {
      additionalData.dope_key = dopeKey;
    }

    if (!additionalData.campaign_name) {
      additionalData.campaign_name = campaignName;
    }

    const data = {
      evn,
      ui: userIdTrack,
      t: trackerTime,
      ...additionalData,
      ...journeyPayload,
    };
    if (typeof tracker.event === 'function') {
      tracker.event(data);
    }
  }
  function trackActionDigitalTrx(
    screenName,
    action,
    additionalPayload,
    type,
    timestamp = null,
  ) {
    const transactionType = type.replace('-', '_');
    const payload = {
      action: `${transactionType}_${screenName}_screen_${action}`,
      screen_name: `${transactionType}_${screenName}_screen`,
      ...additionalPayload,
      timestamp,
    };

    if (['digital-send'].includes(type)) {
      payload.url = window.location.href;
    }

    track(trackerSchema.eventSchema, {
      ...payload,
    });
  }
  function updateReferrer(customReferrer = null) {
    referrer = customReferrer || window.location.href;
  }
  function updateSource(customSource) {
    source = customSource;
  }
  function setAppJourneyID(appJourneyIDParam) {
    if (appJourneyIDParam && appJourneyIDParam !== '') {
      sessionStorage.setItem('new_tracker_app_journey_id', appJourneyIDParam);
      appJourneyID = appJourneyIDParam;
    }
  }
  function setSourceType(sourceTypeParam) {
    sourceType = sourceTypeParam;
  }
  function setChannelType(channelTypeParam) {
    channelType = channelTypeParam;
  }
  function setSubchannel(subchannelParam) {
    subchannel = subchannelParam;
  }
  function setCampaignName(campaignNameParam) {
    campaignName = campaignNameParam;
  }
  function setMedia(mediaParam) {
    media = mediaParam;
  }
  function setDopeKey(dopeKeyParam) {
    dopeKey = dopeKeyParam;
  }
  return {
    track,
    trackActionDigitalTrx,
    updateReferrer,
    updateSource,
    setAppJourneyID,
    setSourceType,
    setChannelType,
    setSubchannel,
    setCampaignName,
    setMedia,
    setDopeKey,
  };
}
export default lakuPandaiDigitalTrxTrackerFactory;
